<template>
  <div class="concept-taxes">
    <div class="detail-title-container is-flex">
      <h5 class="title is-5">
        Impuestos
      </h5>

      <div
        v-if="!disabled"
        class="is-centered"
      >
        <BField class="new-tax">
          <BSelect
            v-model="newTaxType"
            placeholder="Tipo"
          >
            <option value="retained">
              Retención
            </option>
            <option value="transfer">
              Traslado
            </option>
            <option value="localTransfer">
              Traslado Local
            </option>
            <option value="localWithHold">
              Retenciones Locales
            </option>
          </BSelect>
        </BField>
        <BField class="new-tax">
          <BSelect
            v-model="newTaxTax"
            placeholder="Impuesto"
          >
            <option
              v-if="newTaxType === 'retained'"
              value="001"
            >
              ISR
            </option>
            <option
              v-if="['transfer', 'retained'].includes(newTaxType)"
              value="002"
            >
              IVA
            </option>
            <option
              v-if="newTaxType === 'transfer'"
              value="003"
            >
              IEPS
            </option>
            <option
              v-if="newTaxType === 'localTransfer'"
              value="ISH"
            >
              ISH
            </option>
            <option
              v-if="newTaxType === 'localWithHold'"
              value="millar"
            >
              N al millar
            </option>
            <option
              v-if="newTaxType === 'localWithHold'"
              value="cedular"
            >
              Cedular
            </option>
          </BSelect>
        </BField>
        <BField class="new-tax">
          <BSelect
            v-model="newTaxFactorType"
            placeholder="Tasa/Cuota"
          >
            <option value="Tasa">
              Tasa
            </option>
            <option
              v-if="newTaxTax === '003'"
              value="Cuota"
            >
              Cuota
            </option>
            <option
              v-if="['002', '003'].includes(newTaxTax) && newTaxType !== 'retained'"
              value="Exento"
            >
              Exento
            </option>
          </BSelect>
        </BField>
        <BField
          v-if="newTaxTax === '001' && newTaxType === 'retained'"
          class="new-tax fee"
          message="0.00 - 0.35"
        >
          <BInput
            ref="inputNumber"
            v-model="newTaxFee"
            type="number"
            placeholder="0.00"
            step="0.000001"
            min="0.00"
            max="0.35"
            expanded
          />
        </BField>
        <BField
          v-else-if="newTaxTax === '003' && newTaxFactorType === 'Cuota'"
          class="new-tax fee"
          message="0.00 - 43.77"
        >
          <BInput
            ref="inputNumber"
            v-model="newTaxFee"
            type="number"
            step="0.000001"
            placeholder="0.00"
            min="0.00"
            max="43.77"
            expanded
          />
        </BField>
        <BField
          v-else-if="
            newTaxTax === '002' && newTaxType === 'retained' && newTaxFactorType !== 'Exento'"
          class="new-tax fee"
          message="0.00 - 0.16"
        >
          <BInput
            ref="inputNumber"
            v-model="newTaxFee"
            type="number"
            step="0.000001"
            min="0.00"
            max="0.16"
            placeholder="0.00"
            expanded
          />
        </BField>
        <BField
          v-else-if="newTaxTax === 'ISH' && newTaxType === 'localTransfer'"
          class="new-tax fee"
          message="0.02 - 0.05"
        >
          <BInput
            ref="inputNumber"
            v-model="newTaxFee"
            type="number"
            step="0.000001"
            min="0.02"
            max="0.05"
            placeholder="0.00"
            expanded
          />
        </BField>
        <BField
          v-else-if="newTaxTax === 'millar' && newTaxType === 'localWithHold'"
          class="new-tax fee"
          message="0.02 | 0.05"
        >
          <BSelect
            v-model="newTaxFee"
            placeholder="Valor"
          >
            <option
              value="0.05"
            >
              5 al millar
            </option>
            <option
              value="0.02"
            >
              2 al millar
            </option>
          </BSelect>
        </BField>
        <BField
          v-else-if="newTaxTax === 'cedular' && newTaxType === 'localWithHold'"
          class="new-tax fee"
          message="0.02 - 0.05"
        >
          <BInput
            ref="inputNumber"
            v-model="newTaxFee"
            type="number"
            placeholder="0.00"
            step="0.000001"
            min="0.02"
            max="0.05"
            expanded
          />
        </BField>
        <BField
          v-else
          class="new-tax"
        >
          <BSelect
            v-model="newTaxFee"
            placeholder="Valor"
          >
            <option
              v-if="
                newTaxTax === '002' && newTaxType === 'transfer' && newTaxFactorType !== 'Exento'"
              value="0.000000"
            >
              0.00
            </option>
            <option
              v-if="
                newTaxTax === '002' && newTaxType === 'transfer' && newTaxFactorType !== 'Exento'"
              value="0.080000"
            >
              0.08
            </option>
            <option
              v-if="
                newTaxTax === '002' && newTaxType === 'transfer' && newTaxFactorType !== 'Exento'"
              value="0.160000"
            >
              0.16
            </option>
            <option
              v-if="
                ['002', '003'].includes(newTaxTax)
                  && (newTaxType === 'transfer' || newTaxType === 'retained')
                  && newTaxFactorType === 'Exento'"
              value="Exento"
            >
              Exento
            </option>
            <template v-if="newTaxTax === '003' && newTaxFactorType === 'Tasa'">
              <option
                v-for="option in iepsFee"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </template>
          </BSelect>
        </BField>

        <a
          v-if="!disabled"
          class="button add-concept is-success is-rounded"
          @click="addTax"
        >
          <BIcon icon="plus" />
          <span>
            Agregar Impuesto
          </span>
        </a>
      </div>
    </div>
    <BTable :data="taxesDetail">
      <template slot-scope="taxProps">
        <BTableColumn
          field="type"
          label="Tipo"
          centered
        >
          {{ taxTypeLabel(taxProps.row.type) }}
        </BTableColumn>
        <BTableColumn
          field="tax"
          label="Impuesto"
          centered
        >
          <span v-if="taxProps.row.tax === '001'">
            ISR
          </span>
          <span v-if="taxProps.row.tax === '002'">
            IVA
          </span>
          <span v-if="taxProps.row.tax === '003'">
            IEPS
          </span>
          <span v-if="taxProps.row.tax === 'ISH'">
            ISH
          </span>
          <span v-if="taxProps.row.tax === 'millar'">
            N al millar
          </span>
          <span v-if="taxProps.row.tax === 'cedular'">
            Cedular
          </span>
        </BTableColumn>
        <BTableColumn
          field="factorType"
          label="Tasa o Cuota"
          centered
        >
          {{ taxProps.row.factorType }}
        </BTableColumn>
        <BTableColumn
          field="fee"
          label="Valor"
          centered
        >
          {{ taxProps.row.fee }}
        </BTableColumn>
        <BTableColumn
          field="amount"
          label="Monto"
          centered
        >
          {{ taxProps.row.amount }}
        </BTableColumn>
        <BTableColumn
          field="actions"
          label=""
          centered
        >
          <a
            v-if="taxesDetail.length > 1 && !disabled"
            class="button is-danger"
            @click="deleteTax(taxProps.row.type, taxProps.row.tax, taxProps.row.fee)"
          >
            <BIcon
              icon="delete"
              aria-hidden="true"
            />
          </a>
        </BTableColumn>
      </template>
    </BTable>
  </div>
</template>

<script>
import merge from 'lodash/merge';

import { mapState, mapMutations } from 'vuex';

import utils from '../../../../lib/utils';

export default {
  name: 'ConceptTaxes',
  props: {
    id: { type: Number, default: 0 },
    unit: { type: Number, default: 0 },
    quantity: { type: Number, default: 0 },
    taxTransfers: { type: Array, default: () => ([]) },
    retainedTaxes: { type: Array, default: () => ([]) },
    localTaxTransfers: { type: Array, default: () => ([]) },
    localTaxWithHolds: { type: Array, default: () => ([]) },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      newTaxType: null,
      newTaxTax: null,
      newTaxFactorType: null,
      newTaxFee: null,
      iepsFee: [
        { value: 1.600000, label: 1.60 },
        { value: 0.530000, label: 0.53 },
        { value: 0.500000, label: 0.50 },
        { value: 0.304000, label: 0.304 },
        { value: 0.300000, label: 0.30 },
        { value: 0.265000, label: 0.265 },
        { value: 0.250000, label: 0.25 },
        { value: 0.090000, label: 0.09 },
        { value: 0.080000, label: 0.08 },
        { value: 0.070000, label: 0.07 },
        { value: 0.060000, label: 0.06 },
        { value: 0.030000, label: 0.03 },
        { value: 0.000000, label: 0.00 },
      ],
    };
  },
  computed: merge(
    mapState({ voucherCurrency: ({ invoice }) => invoice.voucherCurrency }),
    {
      taxTypeLabel() {
        const types = {
          transfer: 'Traslado',
          retained: 'Retenido',
          localTransfer: 'Traslado Local',
          localWithHold: 'Retenciones Locales',
        };
        return label => types[label];
      },
      completeTax() {
        return (tax) => {
          const amount = (
            utils.standardRounding(
              parseFloat(this.unit) * parseFloat(this.quantity),
              this.voucherCurrency,
            )
          ) * parseFloat(tax.fee || 0);

          const amountWithCurrency = utils.standardRounding(amount, this.voucherCurrency);

          return {
            ...tax,
            type: tax.type || 'transfer',
            base: parseFloat(this.unit) * parseFloat(this.quantity),
            amount: tax.fee ? amountWithCurrency : null,
          };
        };
      },
      taxesDetail() {
        return this.taxTransfers.map(this.completeTax)
          .concat(this.retainedTaxes.map(this.completeTax))
          .concat(this.localTaxTransfers.map(this.completeTax))
          .concat(this.localTaxWithHolds.map(this.completeTax));
      },
    },
  ),
  methods: merge(
    mapMutations({
      addConceptTax: 'invoice/addConceptTax',
      deleteConceptTax: 'invoice/deleteConceptTax',
    }),
    {
      addTax() {
        if (this.$refs.inputNumber) {
          if (!this.$refs.inputNumber.checkHtml5Validity()) return;
        }

        const canCreate = this.newTaxType
          && this.newTaxTax
          && this.newTaxFactorType;

        if (!canCreate) return;

        const taxFeeParsed = parseFloat(this.newTaxFee);
        const isExcent = Number.isNaN(Number(taxFeeParsed));

        this.addConceptTax({
          index: this.id,
          tax: {
            type: this.newTaxType,
            tax: this.newTaxTax,
            factorType: this.newTaxFactorType,
            fee: isExcent ? null : this.newTaxFee,
          },
        });

        this.newTaxType = null;
        this.newTaxTax = null;
        this.newTaxFactorType = null;
        this.newTaxFee = null;
        this.show = true;
      },
      deleteTax(type, tax, fee) {
        this.deleteConceptTax({
          type,
          fee,
          tax,
          index: this.id,
        });
      },
    },
  ),
};
</script>

<style scoped>
.detail-title-container {
  padding-bottom: 1rem;
  width: 100%;
  align-items: center;
  padding-bottom: .3rem;
  justify-content: space-between;
}

.new-tax {
  margin-bottom: 0!important;
  margin-right: .5rem;
}

.new-tax.fee {
  display: flex;
  flex-direction: column-reverse;
  position: relative;
}

.title.is-5 {
  margin-bottom: 0;
}
</style>

<style>
.new-tax.fee .help {
  position: absolute;
  top: -1.25rem;
  width: 100%;
  text-align: right;
}
</style>
